import { useEffect, useState } from "react";

export const AboutImageCarousel = ({ images }) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setActive((current) => (current + 1) % images.length);
    }, 2000);

    return () => window.clearTimeout(timer);
  }, [active, images.length]);

  return (
    <div className="relative h-full w-full" data-testid="about-image-carousel">
      {images.map((src, index) => (
        <img
          key={src}
          src={src}
          alt=""
          aria-hidden
          loading="eager"
          data-active={active === index}
          data-testid={`about-carousel-image-${index + 1}`}
          className={`absolute inset-0 h-full w-full object-cover grayscale transition-[filter,opacity,transform] duration-700 group-hover:grayscale-0 group-hover:scale-105 ${
            active === index ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}

      <div
        className="absolute bottom-4 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2 rounded-full border border-white/10 bg-black/45 px-3 py-2 backdrop-blur-md"
        data-testid="about-carousel-controls"
      >
        {images.map((src, index) => (
          <button
            key={src}
            type="button"
            aria-label={`Show About OORU image ${index + 1}`}
            onClick={() => setActive(index)}
            data-active={active === index}
            data-testid={`about-carousel-control-button-${index + 1}`}
            className={`h-2.5 rounded-full transition-[width,background-color,opacity,transform] duration-300 hover:-translate-y-0.5 ${
              active === index ? "w-7 bg-white opacity-100" : "w-2.5 bg-white/50 opacity-70"
            }`}
          />
        ))}
      </div>
    </div>
  );
};